/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { useEffect, useState } from 'react'
import req from '@sportninja/common/api/request'
import { t } from '@sportninja/common/i18n'

import { feedItemForm } from '../../components/Form/form-configs'
import FormSheet from '../../components/Form/FormSheet'
import {
  DisabledButton,
  LoadingButton,
  NewPostButton,
} from './SidebarComponents'

const filterForAdminAndUpdatePermission = (response) => {
  const { data, meta } = response
  if (!data || !meta || !meta?.permissions) return []

  return response.data.filter((d) => {
    const permission = meta.permissions[d?.id]
    return permission?.update || permission?.admin
  })
}

const HomeSidebarNewPost = ({ refreshFeed }) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const [orgs, setOrgs] = useState([])
  const [scheds, setSched] = useState([])
  const [teams, setTeams] = useState([])

  useEffect(() => {
    setLoading(true)
    setError(false)
    const promises = [
      req('/users/me/organizations'),
      req('/users/me/schedules'),
      req('/users/me/teams'),
    ]

    Promise.all(promises)
      .then(([org, sched, teams]) => {
        setOrgs(filterForAdminAndUpdatePermission(org))
        setSched(filterForAdminAndUpdatePermission(sched))
        setTeams(filterForAdminAndUpdatePermission(teams))
        setLoading(false)
      })
      .catch((e) => {
        setError(e?.message || 'There was a problem.')
      })
  }, [])

  if (error) return false

  const hasNoPermissions =
    orgs.length === 0 && teams.length === 0 && scheds.length === 0

  return (
    <div
      css={css`
        margin-top: 16px;
      `}
    >
      <FormSheet
        label={t('Web:createANewPost')}
        title={t('Web:createANewPost')}
        form={feedItemForm(
          {
            orgs,
            teams,
            scheds,
          },
          true
        )}
        onSubmit={async ({ parent_id, entityType, imageData, ...form }) => {
          const body = JSON.stringify({
            ...form,
          })
          const response = await req(
            `/${entityType}/${parent_id}/social-feed`,
            {
              method: 'POST',
              body,
            }
          )
          if (imageData) {
            await req(`/social-feed/${response.data.id}/image`, {
              method: 'POST',
              body: imageData,
            })
          }
          await refreshFeed()
        }}
        Button={
          loading
            ? LoadingButton
            : hasNoPermissions
            ? DisabledButton
            : NewPostButton
        }
      />
    </div>
  )
}

export default HomeSidebarNewPost
